import type { FlatTranslationKey } from '@/core/types/i18n';

export type AppointmentTranslateFn = (key: FlatTranslationKey) => string;

export function getAppointmentLabels(t: AppointmentTranslateFn) {
  return {
    BOOK_TITLE: t('bookAppointment.bookAppointment'),
    RESCHEDULE_TITLE: t('bookAppointment.reschedule'),
    SLOT_SUBTITLE: t('bookAppointment.slotSubtitle'),
    SLOT_DATE: t('bookAppointment.slotDate'),
    SLOT_TIME: t('bookAppointment.slotTime'),
    TODAY: t('bookAppointment.today'),
    TOMORROW: t('bookAppointment.tomorrow'),
    CANCEL: t('common.cancel'),
    BOOK_CTA: t('bookAppointment.bookAppointment'),
    RESCHEDULE_CTA: t('bookAppointment.reschedule'),
    RESCHEDULE_CTA_MOBILE: t('propertyDetails.reschedule'),
    CONFIRMED_TITLE: t('propertyDetails.appointmentConfirmedTitle'),
    CONFIRMED_DATE: t('propertyDetails.date'),
    CONFIRMED_TIME: t('propertyDetails.time'),
    CONFIRMED_AGENT: t('propertyDetails.contactPersonName'),
    CONFIRMED_PHONE: t('propertyDetails.phoneNumber'),
    OK: t('common.ok'),
    STATUS_TITLE: t('propertyDetails.appointmentConfirmedTitle'),
    STATUS_CANCEL: t('propertyDetails.cancelAppointment'),
    STATUS_RESCHEDULE: t('propertyDetails.reschedule'),
    CANCEL_TITLE: t('propertyDetails.cancelAppointment'),
    CANCEL_MESSAGE: t('bookAppointment.cancelMessage'),
    CANCEL_NO: t('common.no'),
    CANCEL_YES: t('common.yes'),
    CANCELED_TITLE: t('bookAppointment.canceledTitle'),
    CANCELED_MESSAGE: t('bookAppointment.canceledMessage'),
    SLOTS_EMPTY: t('bookAppointment.slotsEmpty'),
    RAISE_SUPPORT_TICKET: t('auth.raiseSupportTicket'),
    SLOTS_ERROR: t('bookAppointment.slotsError'),
    SLOTS_NONE_AVAILABLE: t('bookAppointment.slotsNoneAvailable'),
    SLOT_NO_LONGER_AVAILABLE: t('bookAppointment.slotNoLongerAvailable'),
    BOOK_ERROR: t('bookAppointment.bookError'),
    RESCHEDULE_ERROR: t('bookAppointment.rescheduleError'),
    CANCEL_ERROR: t('bookAppointment.cancelError'),
  } as const;
}

export type AppointmentLabels = ReturnType<typeof getAppointmentLabels>;
